import { createSlice, nanoid } from '@reduxjs/toolkit';

const storageKey = 'resturent_iot_pest_control_v1';

const fallbackRecords = [
  {
    id: nanoid(),
    month: '2026-06',
    provider: 'Shield Pest Services',
    treatmentType: 'Monthly spray treatment',
    areasCovered: 'Kitchen, storage, loading bay',
    nextDue: '2026-07-10',
    status: 'Completed',
    technician: 'John Miller',
    notes: 'All critical zones treated and signed off.',
  },
];

function loadRecords() {
  if (typeof window === 'undefined') return fallbackRecords;
  try {
    const raw = window.localStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) : fallbackRecords;
  } catch {
    return fallbackRecords;
  }
}

function saveRecords(records) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(storageKey, JSON.stringify(records));
}

const pestControlSlice = createSlice({
  name: 'pestControl',
  initialState: { records: loadRecords() },
  reducers: {
    addRecord: {
      reducer(state, action) {
        state.records.unshift(action.payload);
        saveRecords(state.records);
      },
      prepare(record) {
        return { payload: { ...record, id: nanoid() } };
      },
    },
    updateRecord(state, action) {
      const { id, updates } = action.payload;
      const index = state.records.findIndex((record) => record.id === id);
      if (index !== -1) {
        state.records[index] = { ...state.records[index], ...updates };
        saveRecords(state.records);
      }
    },
    deleteRecord(state, action) {
      state.records = state.records.filter((record) => record.id !== action.payload);
      saveRecords(state.records);
    },
  },
});

export const { addRecord, updateRecord, deleteRecord } = pestControlSlice.actions;
export const selectPestControlRecords = (state) => state.pestControl.records;
export default pestControlSlice.reducer;
